import { Link } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';
import './Terms.css';

export default function Terms() {
  const { t, language } = useLanguage();

  return (
    <div className="terms-page">
      <div className="container">
        <div className="terms-content">
          {/* Header */}
          <div className="terms-header">
            <h1 className="terms-title">
              {language === 'ru' ? 'Пользовательское соглашение' : 'Terms of Use'} /{' '}
              {language === 'ru' ? 'Terms of Use' : 'Пользовательское соглашение'}
            </h1>
            <p className="terms-last-updated">
              {language === 'ru' ? 'Дата последнего обновления' : 'Last Updated'}: 17 октября 2025 г. / October 17, 2025
            </p>
          </div>

          {/* Section 1 */}
          <section className="terms-section">
            <h2 className="terms-section-title">
              1. {language === 'ru' ? 'Общие положения' : 'General Provisions'} /{' '}
              {language === 'ru' ? 'General Provisions' : 'Общие положения'}
            </h2>
            <div className="terms-bilingual">
              <div className="terms-text-block">
                <p>
                  Настоящее Пользовательское соглашение (далее — «Соглашение») определяет условия использования мобильного приложения и Telegram-бота «Площадка» (далее — «Приложение»), принадлежащего Обществу с ограниченной ответственностью «ГАЛС» (ООО «ГАЛС», ИНН 1657087881, КПП 1165701001, Россия, 420140, г. Казань, ул. Лаврентьева, д. 11, пом. 1045-1) — далее «Оператор».
                </p>
                <p>
                  Используя Приложение, Пользователь подтверждает, что прочитал, понял и согласен соблюдать условия настоящего Соглашения. Если Пользователь не согласен с условиями Соглашения, он должен прекратить использование Приложения.
                </p>
              </div>
              <div className="terms-text-block">
                <p>
                  This Terms of Use Agreement ("Agreement") sets forth the terms and conditions for using the mobile application and Telegram bot "Ploshadka" ("the App"), owned by LLC "GALS" (TIN 1657087881, KPP 1165701001, Russia, 420140, Kazan, Lavrentyeva St. 11, office 1045-1) — hereinafter referred to as "the Operator."
                </p>
                <p>
                  By using the App, the User confirms that they have read, understood, and agree to comply with the terms of this Agreement. If the User does not agree to the terms of this Agreement, they must stop using the App.
                </p>
              </div>
            </div>
          </section>

          {/* Section 2 */}
          <section className="terms-section">
            <h2 className="terms-section-title">
              2. {language === 'ru' ? 'Предмет соглашения' : 'Subject Matter'} /{' '}
              {language === 'ru' ? 'Subject Matter' : 'Предмет соглашения'}
            </h2>
            <div className="terms-bilingual">
              <div className="terms-text-block">
                <p>
                  Приложение предоставляет информационно-справочный сервис для поиска спортивных площадок, организации встреч и взаимодействия между пользователями. Оператор не оказывает спортивные услуги и не является владельцем или оператором спортивных объектов.
                </p>
                <p>
                  Оператор действует исключительно как информационный посредник и технический платформенный сервис, предоставляющий пользователям возможность обмена информацией и взаимодействия.
                </p>
              </div>
              <div className="terms-text-block">
                <p>
                  The App provides an informational and reference service for finding sports venues, organizing meetings, and facilitating interaction between users. The Operator does not provide sports services and is not the owner or operator of sports facilities.
                </p>
                <p>
                  The Operator acts solely as an information intermediary and technical platform service, providing users with the ability to exchange information and interact.
                </p>
              </div>
            </div>
          </section>

          {/* Section 3 */}
          <section className="terms-section">
            <h2 className="terms-section-title">
              3. {language === 'ru' ? 'Информация о спортивных объектах' : 'Information About Sports Facilities'} /{' '}
              {language === 'ru' ? 'Information About Sports Facilities' : 'Информация о спортивных объектах'}
            </h2>
            <div className="terms-bilingual">
              <div className="terms-text-block">
                <p>
                  <strong>3.1. Справочный характер информации</strong>
                </p>
                <p>
                  Вся информация о спортивных объектах, площадках, их характеристиках, расписании, ценах, доступности и иных параметрах предоставляется Оператором исключительно в справочных целях. Оператор не гарантирует полноту, точность, актуальность и соответствие действительности указанной информации.
                </p>
                <p>
                  <strong>3.2. Ответственность за актуальность данных</strong>
                </p>
                <p>
                  Оператор не несет ответственности за несоответствие информации, размещенной в Приложении, фактическому состоянию спортивных объектов, их расписанию, ценам, доступности и иным параметрам. Пользователь обязуется самостоятельно уточнять актуальную информацию непосредственно у администрации спортивных объектов перед использованием их услуг.
                </p>
                <p>
                  <strong>3.3. Изменения информации</strong>
                </p>
                <p>
                  Информация о спортивных объектах может изменяться без уведомления Пользователей. Оператор не гарантирует своевременное обновление информации и не несет ответственности за последствия использования устаревшей информации.
                </p>
              </div>
              <div className="terms-text-block">
                <p>
                  <strong>3.1. Reference Nature of Information</strong>
                </p>
                <p>
                  All information about sports facilities, venues, their characteristics, schedules, prices, availability, and other parameters is provided by the Operator solely for reference purposes. The Operator does not guarantee the completeness, accuracy, relevance, or correspondence to reality of such information.
                </p>
                <p>
                  <strong>3.2. Responsibility for Data Accuracy</strong>
                </p>
                <p>
                  The Operator is not responsible for any discrepancy between information posted in the App and the actual state of sports facilities, their schedules, prices, availability, and other parameters. The User agrees to independently verify current information directly with the administration of sports facilities before using their services.
                </p>
                <p>
                  <strong>3.3. Information Changes</strong>
                </p>
                <p>
                  Information about sports facilities may change without notice to Users. The Operator does not guarantee timely updates of information and is not responsible for consequences arising from the use of outdated information.
                </p>
              </div>
            </div>
          </section>

          {/* Section 4 */}
          <section className="terms-section">
            <h2 className="terms-section-title">
              4. {language === 'ru' ? 'Расписание и бронирования' : 'Schedules and Bookings'} /{' '}
              {language === 'ru' ? 'Schedules and Bookings' : 'Расписание и бронирования'}
            </h2>
            <div className="terms-bilingual">
              <div className="terms-text-block">
                <p>
                  <strong>4.1. Функция бронирования</strong>
                </p>
                <p>
                  В случае, если в Приложении предусмотрена функция бронирования спортивных площадок, Оператор предоставляет техническую возможность для осуществления бронирования, но не несет ответственности за фактическое предоставление услуг спортивными объектами.
                </p>
                <p>
                  <strong>4.2. Ответственность администрации объекта</strong>
                </p>
                <p>
                  Вся ответственность за расписание, доступность площадок, подтверждение бронирований, отмену бронирований, изменение условий бронирования, а также за фактическое предоставление услуг несет исключительно администрация соответствующего спортивного объекта. Оператор не является стороной договорных отношений между Пользователем и спортивным объектом.
                </p>
                <p>
                  <strong>4.3. Отмена и изменение бронирований</strong>
                </p>
                <p>
                  Оператор не несет ответственности за отмену бронирований администрацией спортивных объектов, изменение условий бронирования, недоступность площадок, а также за любые убытки, возникшие в связи с невозможностью использования забронированной площадки.
                </p>
              </div>
              <div className="terms-text-block">
                <p>
                  <strong>4.1. Booking Function</strong>
                </p>
                <p>
                  If the App provides a booking function for sports venues, the Operator provides technical capability for making bookings but is not responsible for the actual provision of services by sports facilities.
                </p>
                <p>
                  <strong>4.2. Facility Administration Responsibility</strong>
                </p>
                <p>
                  All responsibility for schedules, venue availability, booking confirmations, booking cancellations, changes to booking terms, and the actual provision of services lies solely with the administration of the respective sports facility. The Operator is not a party to contractual relationships between the User and the sports facility.
                </p>
                <p>
                  <strong>4.3. Cancellation and Changes to Bookings</strong>
                </p>
                <p>
                  The Operator is not responsible for booking cancellations by sports facility administrations, changes to booking terms, venue unavailability, or any losses arising from the inability to use a booked venue.
                </p>
              </div>
            </div>
          </section>

          {/* Section 5 */}
          <section className="terms-section">
            <h2 className="terms-section-title">
              5. {language === 'ru' ? 'Платежи и агентские отношения' : 'Payments and Agency Relations'} /{' '}
              {language === 'ru' ? 'Payments and Agency Relations' : 'Платежи и агентские отношения'}
            </h2>
            <div className="terms-bilingual">
              <div className="terms-text-block">
                <p>
                  <strong>5.1. Агентский статус Оператора</strong>
                </p>
                <p>
                  При осуществлении бронирований и оплат через Приложение Оператор действует исключительно в качестве агента, осуществляющего техническую обработку платежей и передачу средств соответствующим спортивным объектам. Оператор не оказывает спортивные услуги и не является исполнителем по договорам оказания услуг.
                </p>
                <p>
                  <strong>5.2. Отношения между Пользователем и спортивным объектом</strong>
                </p>
                <p>
                  Договорные отношения по оказанию спортивных услуг возникают непосредственно между Пользователем и соответствующим спортивным объектом. Оператор не является стороной таких договорных отношений и не несет ответственности за качество, полноту и своевременность оказания услуг спортивными объектами.
                </p>
                <p>
                  <strong>5.3. Возврат средств</strong>
                </p>
                <p>
                  Вопросы возврата средств, отмены бронирований и урегулирования споров решаются непосредственно между Пользователем и спортивным объектом. Оператор не несет ответственности за возврат средств и урегулирование споров, за исключением случаев технических ошибок при обработке платежей.
                </p>
              </div>
              <div className="terms-text-block">
                <p>
                  <strong>5.1. Operator's Agency Status</strong>
                </p>
                <p>
                  When processing bookings and payments through the App, the Operator acts solely as an agent, providing technical processing of payments and transfer of funds to the respective sports facilities. The Operator does not provide sports services and is not a service provider under service agreements.
                </p>
                <p>
                  <strong>5.2. Relations Between User and Sports Facility</strong>
                </p>
                <p>
                  Contractual relations for the provision of sports services arise directly between the User and the respective sports facility. The Operator is not a party to such contractual relations and is not responsible for the quality, completeness, and timeliness of services provided by sports facilities.
                </p>
                <p>
                  <strong>5.3. Refunds</strong>
                </p>
                <p>
                  Issues of refunds, booking cancellations, and dispute resolution are handled directly between the User and the sports facility. The Operator is not responsible for refunds and dispute resolution, except in cases of technical errors in payment processing.
                </p>
              </div>
            </div>
          </section>

          {/* Section 6 */}
          <section className="terms-section">
            <h2 className="terms-section-title">
              6. {language === 'ru' ? 'Пользовательский контент и ответственность пользователей' : 'User Content and User Responsibility'} /{' '}
              {language === 'ru' ? 'User Content and User Responsibility' : 'Пользовательский контент и ответственность пользователей'}
            </h2>
            <div className="terms-bilingual">
              <div className="terms-text-block">
                <p>
                  <strong>6.1. Ответственность за пользовательский контент</strong>
                </p>
                <p>
                  Пользователь несет полную ответственность за весь контент, который он размещает, публикует, передает или иным образом делает доступным через Приложение, включая, но не ограничиваясь: текстовые сообщения, фотографии, изображения, видео, комментарии, отзывы, личные данные других пользователей, а также за все взаимодействия с другими пользователями.
                </p>
                <p>
                  <strong>6.2. Запрещенный контент</strong>
                </p>
                <p>
                  Пользователь обязуется не размещать контент, который нарушает законодательство Российской Федерации, права третьих лиц, содержит оскорбления, клевету, угрозы, порнографию, призывы к насилию, экстремистские материалы, а также иной контент, нарушающий общепринятые нормы морали и этики.
                </p>
                <p>
                  <strong>6.3. Модерация контента</strong>
                </p>
                <p>
                  Оператор оставляет за собой право удалять, блокировать или иным образом ограничивать доступ к контенту, который, по мнению Оператора, нарушает законодательство, требования государственных органов, общепринятые нормы морали и этики, или по иным основаниям по собственному усмотрению Оператора. Оператор не несет ответственности за контент, размещенный Пользователями, и не обязан предварительно проверять такой контент.
                </p>
                <p>
                  <strong>6.4. Взаимодействие между пользователями</strong>
                </p>
                <p>
                  Оператор не несет ответственности за содержание переписки, общения, договоренностей и иных взаимодействий между Пользователями. Все риски, связанные с общением и взаимодействием с другими Пользователями, несет сам Пользователь.
                </p>
              </div>
              <div className="terms-text-block">
                <p>
                  <strong>6.1. Responsibility for User Content</strong>
                </p>
                <p>
                  The User is fully responsible for all content they post, publish, transmit, or otherwise make available through the App, including but not limited to: text messages, photos, images, videos, comments, reviews, personal data of other users, and all interactions with other users.
                </p>
                <p>
                  <strong>6.2. Prohibited Content</strong>
                </p>
                <p>
                  The User agrees not to post content that violates the laws of the Russian Federation, the rights of third parties, contains insults, defamation, threats, pornography, calls for violence, extremist materials, or other content that violates generally accepted moral and ethical standards.
                </p>
                <p>
                  <strong>6.3. Content Moderation</strong>
                </p>
                <p>
                  The Operator reserves the right to delete, block, or otherwise restrict access to content that, in the Operator's opinion, violates laws, requirements of government agencies, generally accepted moral and ethical standards, or on other grounds at the Operator's sole discretion. The Operator is not responsible for content posted by Users and is not obligated to pre-screen such content.
                </p>
                <p>
                  <strong>6.4. User Interactions</strong>
                </p>
                <p>
                  The Operator is not responsible for the content of correspondence, communication, agreements, and other interactions between Users. All risks associated with communication and interaction with other Users are borne by the User themselves.
                </p>
              </div>
            </div>
          </section>

          {/* Section 7 */}
          <section className="terms-section">
            <h2 className="terms-section-title">
              7. {language === 'ru' ? 'Ограничение ответственности' : 'Limitation of Liability'} /{' '}
              {language === 'ru' ? 'Limitation of Liability' : 'Ограничение ответственности'}
            </h2>
            <div className="terms-bilingual">
              <div className="terms-text-block">
                <p>
                  <strong>7.1. Общие ограничения</strong>
                </p>
                <p>
                  Оператор не несет ответственности за любой ущерб, прямой или косвенный, включая, но не ограничиваясь: упущенную выгоду, потерю данных, ущерб репутации, возникший в результате использования или невозможности использования Приложения, а также в результате действий или бездействия третьих лиц, включая спортивные объекты и других Пользователей.
                </p>
                <p>
                  <strong>7.2. Технические сбои</strong>
                </p>
                <p>
                  Оператор не гарантирует бесперебойную работу Приложения и не несет ответственности за технические сбои, перерывы в работе, потерю данных, а также за последствия таких сбоев.
                </p>
                <p>
                  <strong>7.3. Действия третьих лиц</strong>
                </p>
                <p>
                  Оператор не несет ответственности за действия или бездействие спортивных объектов, других Пользователей, а также любых третьих лиц, включая государственные органы, провайдеров услуг связи и иных лиц.
                </p>
              </div>
              <div className="terms-text-block">
                <p>
                  <strong>7.1. General Limitations</strong>
                </p>
                <p>
                  The Operator is not liable for any damage, direct or indirect, including but not limited to: lost profits, data loss, reputational damage, arising from the use or inability to use the App, as well as from the actions or inaction of third parties, including sports facilities and other Users.
                </p>
                <p>
                  <strong>7.2. Technical Failures</strong>
                </p>
                <p>
                  The Operator does not guarantee uninterrupted operation of the App and is not responsible for technical failures, service interruptions, data loss, or the consequences of such failures.
                </p>
                <p>
                  <strong>7.3. Third-Party Actions</strong>
                </p>
                <p>
                  The Operator is not responsible for the actions or inaction of sports facilities, other Users, or any third parties, including government agencies, telecommunications service providers, and other persons.
                </p>
              </div>
            </div>
          </section>

          {/* Section 8 */}
          <section className="terms-section">
            <h2 className="terms-section-title">
              8. {language === 'ru' ? 'Интеллектуальная собственность' : 'Intellectual Property'} /{' '}
              {language === 'ru' ? 'Intellectual Property' : 'Интеллектуальная собственность'}
            </h2>
            <div className="terms-bilingual">
              <div className="terms-text-block">
                <p>
                  <strong>8.1. Права на материалы Приложения</strong>
                </p>
                <p>
                  Все права на Приложение, включая программное обеспечение, дизайн, логотипы, тексты, графику и иные материалы, принадлежат Оператору или его лицензиарам и защищены законодательством об интеллектуальной собственности.
                </p>
                <p>
                  Пользователь не вправе копировать, модифицировать, распространять, продавать или иным образом использовать материалы Приложения без письменного разрешения Оператора.
                </p>
                <p>
                  <strong>8.2. Фотографии и изображения спортивных объектов</strong>
                </p>
                <p>
                  Многие фотографии и изображения спортивных объектов, размещенные в Приложении, были получены Оператором из открытых источников (включая, но не ограничиваясь: публичные базы данных, открытые репозитории изображений, официальные сайты спортивных объектов, социальные сети и иные публично доступные источники). Оператор не является правообладателем таких изображений и не претендует на авторские права на них.
                </p>
                <p>
                  Оператор использует такие изображения исключительно в информационно-справочных целях для иллюстрации спортивных объектов. В случае возникновения претензий со стороны правообладателей изображений Оператор обязуется рассмотреть такие претензии и при необходимости удалить соответствующие изображения из Приложения.
                </p>
                <p>
                  Оператор не несет ответственности за возможное нарушение авторских прав третьих лиц в отношении изображений, размещенных в Приложении, если такие изображения были получены из открытых источников. Все претензии по авторским правам на изображения должны направляться непосредственно Оператору для рассмотрения.
                </p>
              </div>
              <div className="terms-text-block">
                <p>
                  <strong>8.1. Rights to App Materials</strong>
                </p>
                <p>
                  All rights to the App, including software, design, logos, texts, graphics, and other materials, belong to the Operator or its licensors and are protected by intellectual property laws.
                </p>
                <p>
                  The User may not copy, modify, distribute, sell, or otherwise use the App's materials without written permission from the Operator.
                </p>
                <p>
                  <strong>8.2. Photographs and Images of Sports Facilities</strong>
                </p>
                <p>
                  Many photographs and images of sports facilities posted in the App were obtained by the Operator from open sources (including but not limited to: public databases, open image repositories, official websites of sports facilities, social networks, and other publicly available sources). The Operator is not the copyright holder of such images and does not claim copyright to them.
                </p>
                <p>
                  The Operator uses such images solely for informational and reference purposes to illustrate sports facilities. In case of claims from copyright holders of images, the Operator undertakes to consider such claims and, if necessary, remove the corresponding images from the App.
                </p>
                <p>
                  The Operator is not responsible for possible copyright infringement by third parties regarding images posted in the App if such images were obtained from open sources. All copyright claims regarding images must be sent directly to the Operator for consideration.
                </p>
              </div>
            </div>
          </section>

          {/* Section 9 */}
          <section className="terms-section">
            <h2 className="terms-section-title">
              9. {language === 'ru' ? 'Изменение условий соглашения' : 'Changes to Agreement Terms'} /{' '}
              {language === 'ru' ? 'Changes to Agreement Terms' : 'Изменение условий соглашения'}
            </h2>
            <div className="terms-bilingual">
              <div className="terms-text-block">
                <p>
                  Оператор вправе в одностороннем порядке изменять условия настоящего Соглашения без предварительного уведомления Пользователей. Изменения вступают в силу с момента их публикации в Приложении или на сайте sportsground.ru.
                </p>
                <p>
                  Продолжение использования Приложения после внесения изменений означает согласие Пользователя с новыми условиями Соглашения.
                </p>
              </div>
              <div className="terms-text-block">
                <p>
                  The Operator has the right to unilaterally change the terms of this Agreement without prior notice to Users. Changes take effect from the moment they are published in the App or on sportsground.ru.
                </p>
                <p>
                  Continued use of the App after changes are made constitutes the User's agreement to the new terms of the Agreement.
                </p>
              </div>
            </div>
          </section>

          {/* Section 10 */}
          <section className="terms-section">
            <h2 className="terms-section-title">
              10. {language === 'ru' ? 'Контактная информация' : 'Contact Information'} /{' '}
              {language === 'ru' ? 'Contact Information' : 'Контактная информация'}
            </h2>
            <div className="terms-bilingual">
              <div className="terms-text-block">
                <p>
                  <strong>Оператор / Operator:</strong> ООО «ГАЛС» / LLC "GALS"
                </p>
                <p>
                  <strong>Адрес / Address:</strong> Россия, 420140, г. Казань, ул. Лаврентьева, 11, пом. 1045-1 / Lavrentyeva St. 11, office 1045-1, Kazan, 420140, Russia
                </p>
                <p>
                  <strong>E-mail:</strong> <a href="mailto:azatatata@gmail.com">azatatata@gmail.com</a>
                </p>
                <p>
                  <strong>Telegram:</strong> <a href="https://t.me/plschdk_bot" target="_blank" rel="noopener noreferrer">@plschdk_bot</a>
                </p>
                <p>
                  <strong>Website:</strong> <a href="https://sportsground.ru" target="_blank" rel="noopener noreferrer">sportsground.ru</a>
                </p>
              </div>
              <div className="terms-text-block">
                <p>
                  <strong>Operator / Оператор:</strong> LLC "GALS" / ООО «ГАЛС»
                </p>
                <p>
                  <strong>Address / Адрес:</strong> Lavrentyeva St. 11, office 1045-1, Kazan, 420140, Russia / Россия, 420140, г. Казань, ул. Лаврентьева, 11, пом. 1045-1
                </p>
                <p>
                  <strong>E-mail:</strong> <a href="mailto:azatatata@gmail.com">azatatata@gmail.com</a>
                </p>
                <p>
                  <strong>Telegram:</strong> <a href="https://t.me/plschdk_bot" target="_blank" rel="noopener noreferrer">@plschdk_bot</a>
                </p>
                <p>
                  <strong>Website:</strong> <a href="https://sportsground.ru" target="_blank" rel="noopener noreferrer">sportsground.ru</a>
                </p>
              </div>
            </div>
          </section>

          {/* Back to Home */}
          <div className="terms-footer">
            <Link to="/" className="btn btn-primary">
              {t('common.backToHome')}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

